/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
};

const ChevronRightIcon: FC<IProps> = ({ width = 20, height = 20, color = "#908E8D", className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path d="M7.5 14.6553L12.5 9.65525L7.5 4.65525" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ChevronRightIcon;
